import React, { useEffect, useState } from "react";
import ModalProps from "./Modal.types";
import "./Modal.scss";
import Button from "../Button/Button";
import { makeStyles } from "@material-ui/core";
import ModalUI from "@material-ui/core/Modal";
import SVG from "../SVG/SVG";
import Loader from "../../utilities/Loader";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: "16px",
    borderRadius: 4,
    fontSize: 10,
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
  },
  subBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Modal = ({
  title,
  showImageModal,
  image,
  modalBtnText,
  imageText,
  handleClick,
  openModal = false,
  call,
  reset,
  showLoaderIcon,
  handoverModal,
  inventoryRequests,
  requestButton,
}: ModalProps) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(openModal);
  const [expandModal, setExpandModal] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [showHandover, setShowHandover] = React.useState(false);
  const [showRequests, setShowRequests] = React.useState(false);

  // const [imageModal, setImageModal] = React.useState(showImageModal); doesnt work when useState is used here, so using the showImageModal directly!!

  useEffect(() => {
    setShowHandover(handoverModal);
  }, [handoverModal]);

  useEffect(() => {
    setShowRequests(requestButton);
  }, [requestButton]);

  useEffect(() => {
    setOpen(openModal);
    //checking screen size and displaying modal pop up
    if (window.innerWidth > 430) {
      setExpandModal(false);
    } else {
      setExpandModal(true);
    }
  }, [openModal]);

  useEffect(() => {
    setShowLoader(showLoaderIcon);
  }, [showLoaderIcon]);

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);

  useEffect(() => {
    if (windowDimenion.winWidth > 430) {
      setExpandModal(false);
    } else {
      setExpandModal(true);
    }
  }, [windowDimenion]);

  const handleOpen = () => {
    handleClick();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setShowLoader(false);
    reset();
  };
  const handleAttendanceSent = () => {
    call();
  };
  const openReveiveRequests = () => {
    inventoryRequests();
  };

  const body = (
    <div
      style={modalStyle}
      className={(expandModal ? "modal85" : "modal25") + " " + classes.paper}
    >
      <div className={classes.box}>
        <h2 className="title" id="simple-modal-title">
          {title}
        </h2>
        <p onClick={() => handleClose()} className="mt-0">
          <SVG type="close" />
        </p>
      </div>
      {/* show text in modal */}
      {!showImageModal && !showHandover && !showRequests && (
        <p
          className={classes.subBox + " " + "mb-0"}
          id="simple-modal-description"
        >
          {showLoader ? (
            <Button
              value="Yes"
              className="Btnmargin mr-0 fs-14 fw-500"
              isRounded={true}
            >
              <Loader
                color="white"
                loading={showLoader}
                size={10}
                height="auto"
              />
            </Button>
          ) : (
            <Button
              value="Yes"
              onClick={() => handleAttendanceSent()}
              className="Btnmargin mr-0 fs-14 fw-500"
              isRounded={true}
            >
              Yes
            </Button>
          )}
          <Button
            value="No"
            onClick={() => handleClose()}
            className="Btnmargin fs-14 fw-500 white-bg color"
            isRounded={true}
          >
            No
          </Button>
        </p>
      )}
      {showHandover && (
        <div className="d-flex column h-center v-center">
          <Button
            value="No"
            onClick={() => handleAttendanceSent()}
            className="BtnmarginHandover ml-05 mr-0 fs-14 fw-500"
            isRounded={true}
          >
            Inventory Handover
          </Button>
        </div>
      )}
      {showRequests && (
        <div className="d-flex column h-center v-center">
          <Button
            value="No"
            onClick={() => openReveiveRequests()}
            className="BtnmarginHandover ml-05 mr-0 fs-14 fw-500"
            isRounded={true}
          >
            Receive Requests
          </Button>
        </div>
      )}
      <div>
        {/* show image in modal */}
        <div className="center">
          {showImageModal && !showHandover && !showRequests && (
            <SVG type={image} />
          )}
        </div>
        {showImageModal && <p className="imageText fs-14">{imageText}</p>}
      </div>
    </div>
  );
  return (
    <div className="btn-container">
      {open && (
        <ModalUI
          open={open}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </ModalUI>
      )}
    </div>
  );
};

export default Modal;
